type PendingReset = { slug: string; token: number } | null

export function useCategoryFilterReset() {
  const pendingReset = useState<PendingReset>('category-filter-reset', () => null)

  /**
   * Category chosen from navigation: forget its saved filters, and signal a live
   * reset for the case where we are already on that category (no navigation happens).
   */
  function requestCategoryReset(slug: string) {
    usePersistedFilters(slug).clearPersistedFilters()
    pendingReset.value = { slug, token: (pendingReset.value?.token ?? 0) + 1 }
  }

  return { pendingReset, requestCategoryReset }
}
